import { defineStore } from "pinia";
import services from "./services";
import { Material, useMaterialesStore } from "./MaterialesStore";
import { ElNotification, UploadUserFile } from "element-plus";
import { Proyecto, useProyectosStore } from "./ProyectosStore";
import Helper from "@/common/Helper";
import { EmailObj } from "./CommonStore";
export interface ProductoAcabado {
  IdPA: number;
  IdProyecto: number;
  Codigo: string;
  Descripcion: string;
  Foto: string | undefined;
  TipoMaterial: string | undefined;
  ItemPromocional: boolean;
  FormulaNocilla: string;
  ForoAprobacionPA: string | undefined;
  Marca: string;
  Familia: string;
  Subfamilia: string;
  FormatoComercial: string;
  UnidadesUMBCaja: number;
  PesoNeto: number | undefined;
  UnidadMedidaBasicaUMB: string | undefined;
  CodigoEANNuevo: string | undefined;
  EANReferencia: string | undefined;
  EANReferenciaOriginal: string | undefined;
  TipoProducto?: string | undefined;
  TipoVenta: string | undefined;
  CanalVenta: string | undefined;
  DiasTotalesConservacion: number;
  Cuarentena: number;
  CosteEstandarUMB: number;
  PrecioPuntoVerdeUMB: number;
  VidaComercial: number;
  Batch: number;
  UnidadPrecioUMB: number;
  ReferenciaModelo: string;
  TempId?: string;
  Deleted?: boolean;
  Documentos?: string;
  FormatoExpositivo: string;
  Lineal: boolean;
  RefInterna: string;
  EditarCodigo: boolean;
  BloquearMateriales: boolean;
  UpdatedCodigoPA?: boolean;
  MedidaMaterial?: string;
  EstadoSAP?: string;
  ComentarioPackaging?: string;
  MotivoCambioFE?: string;
  TipoLanzamiento?: string;
  Centro: string;
}
export interface ProductoAcabadoExtend extends ProductoAcabado {
  [key: string]: any;
}
export interface DocumentoData {
  downloadUrl: string;
  webUrl: string;
  name: string;
  siteId: string;
  itemId: string;
}
// export interface ReferenciaMateriales extends Referencia {
//     Materiales: Material[]
// }
export const useProductosAcabadoStore = defineStore("ProductosAcabadoStore", {
  // convert to a function
  state: () => ({
    ProductosAcabados: [] as ProductoAcabado[] | undefined,
    AllProductosAcabadosEnCurso: [] as ProductoAcabado[] | undefined,
  }),
  getters: {
    GetByIds(state) {
      return (idsReferencia: string[] | undefined) =>
        state.ProductosAcabados?.filter((m: ProductoAcabado) =>
          idsReferencia ? idsReferencia.indexOf(m.Codigo) > -1 : false,
        );
    },
  },
  actions: {
    EmptyProductosAcabados() {
      this.ProductosAcabados = [];
    },
    async GetAllProductoAcabadoEnCurso() {
      await services.ProductoAcabadoService.getAllProductoAcabadoEnCurso()
        .then((result: { data: ProductoAcabado[] }) => {
          this.AllProductosAcabadosEnCurso = result.data;
        })
        .catch((error: Error) => {
          console.error("Error al obtener los productos acabados :", error);
        });
    },
    async GetProductosAcabadosByIds(ids: number[]) {
      if (ids.length > 0) {
        return await services.ProductoAcabadoService.getProductosAcabadosByIds(
          ids,
        );
      }
      return { data: null };
    },
    async GetProductoAcabadoById(idProyecto: number) {
      await services.ProductoAcabadoService.getByIdProyecto(idProyecto)
        .then((result: { data: ProductoAcabado[] }) => {
          this.ProductosAcabados = result.data;
        })
        .catch((error: Error) => {
          console.error(
            "Error al obtener los productos acabados by idproyecto",
            error,
          );
        });
    },
    async AddProductoAcabado(
      data: ProductoAcabado,
    ): Promise<ProductoAcabado | undefined> {
      const ProyectosStore = useProyectosStore();
      const { findMissingNumber, removeSpecialCharacters } = Helper();
      try {
        let refInterna = 1;
        if (this.ProductosAcabados && this.ProductosAcabados.length > 0) {
          const refInternas = this.ProductosAcabados.filter(
            (pa) =>
              pa.RefInterna !== undefined &&
              pa.RefInterna !== null &&
              pa.RefInterna !== "",
          ).map((item) => parseInt(item.RefInterna.replace("R", ""), 10));
          refInterna = findMissingNumber(refInternas);
        }
        data.RefInterna = "R" + refInterna;

        const result = await services.ProductoAcabadoService.add(data);
        await ProyectosStore.GetProyectoById(
          ProyectosStore.ProyectoSelected.IdProyecto,
        );
        const subPath = `${removeSpecialCharacters(ProyectosStore.ProyectoSelected.Descripcion)}/${data.RefInterna}`; // quita caracteres raros y espacios
        services.AzureService.createFolderSP(`${subPath}`);
        console.log("ProductoAcabado añadido correctamente");

        if (this.ProductosAcabados) {
          const index = this.ProductosAcabados.findIndex(
            (i) => i.TempId === data.TempId,
          );
          if (index && index > -1)
            //this.ProductosAcabados[index] = result.data;
            Object.assign(this.ProductosAcabados[index], result.data);
          else this.ProductosAcabados.push(result.data);
        }
        try {
          await this.AddMaterialesToPA(result.data);
        } catch (error: unknown) {
          console.error(
            "Error al añadir Materiales al producto acabado:",
            error,
          );
        }
        return result.data;
      } catch (error: unknown) {
        console.error("Error al añadir el producto acabado:", error);
        throw error;
      }
      return undefined;
    },
    async AddMaterialesToPA(
      result: ProductoAcabado,
      referenciaModelo: string | null = null,
    ) {
      const MaterialesStore = useMaterialesStore();
      const { findMissingNumber } = Helper();
      MaterialesStore.EmptyMaterialesPA();
      if (result.ReferenciaModelo || referenciaModelo) {
        try {
          await MaterialesStore.MaterialesByReferencia(
            Number(referenciaModelo || result.ReferenciaModelo),
          );
          if (MaterialesStore.Materiales) {
            for (let m = 0; m < MaterialesStore.Materiales.length; m++) {
              const material = MaterialesStore.Materiales[m];
              let refInterna = 1;
              if (MaterialesStore.MaterialesPA) {
                const refInternas = MaterialesStore.MaterialesPA.filter(
                  (pa) =>
                    pa.RefInterna !== undefined &&
                    pa.RefInterna !== null &&
                    pa.RefInterna !== "",
                ).map((item) =>
                  parseInt((item.RefInterna as string).replace("M", ""), 10),
                );

                refInterna = findMissingNumber(refInternas);
              }
              material.RefInterna = "M" + refInterna;

              const dataMaterial: Material = {
                IdMaterial: 0,
                IdPA: result.IdPA,
                Codigo: material.Codigo,
                Descripcion: material.Descripcion,
                Tipo: material.Tipo,
                Cantidad: material.Cantidad,
                UM: material.UM,
                CategoriaMaterial: material.CategoriaMaterial ?? "",
                Agencia: material.Agencia ?? "",
                PruebaColor: material.PruebaColor ?? false,
                Diseno3D: material.Diseno3D ?? false,
                ModificarFichaEtiquetado:
                  material.ModificarFichaEtiquetado ?? false,
                ModificarPlano: material.ModificarPlano ?? false,
                Acabado: material.Acabado ?? "",
                LlevaLicencia: material.LlevaLicencia ?? false,
                Referencia: material.Referencia,
                CambioDiseno: material.CambioDiseno,
                RefInterna: material.RefInterna,
                CodigoReemplazado: material.Codigo,
                PrecioUMB: material.PrecioUMB,
                DirectoImpresor: material.DirectoImpresor,
                Merma: material.Merma,
              };
              const materialAdded =
                await services.MaterialService.add(dataMaterial);
              MaterialesStore.UpdateMaterialesPAStore(materialAdded.data);
            }
          }
        } catch (error: any) {
          console.log("Error Add materialesToPA", error);
          throw error;
        }
      }
    },
    async UpdateProductoAcabado(data: ProductoAcabado): Promise<void> {
      const { findMissingNumber, removeSpecialCharacters } = Helper();
      const ProyectosStore = useProyectosStore();
      if (!data.RefInterna) {
        let refInterna = 1;
        if (this.ProductosAcabados && this.ProductosAcabados.length > 0) {
          const refInternas = this.ProductosAcabados.filter(
            (pa) =>
              pa.RefInterna !== undefined &&
              pa.RefInterna !== null &&
              pa.RefInterna !== "",
          ).map((item) => parseInt(item.RefInterna.replace("R", ""), 10));
          refInterna = findMissingNumber(refInternas);
        }
        data.RefInterna = "R" + refInterna;
      }
      await services.ProductoAcabadoService.update(data)
        .then(async () => {
          const index = this.ProductosAcabados?.findIndex(
            (i) => i.IdPA === data.IdPA,
          );
          if (this.ProductosAcabados && index)
            Object.assign(this.ProductosAcabados[index], data);
          console.log("ProductoAcabado update correctamente");

          await ProyectosStore.GetProyectoById(
            ProyectosStore.ProyectoSelected.IdProyecto,
          );
          const result = await services.AzureService.getGraphFolderSP(
            removeSpecialCharacters(
              ProyectosStore.ProyectoSelected.Descripcion,
            ) +
              "/" +
              data.RefInterna,
          );
          if (!result) {
            services.AzureService.createFolderSP(
              removeSpecialCharacters(
                ProyectosStore.ProyectoSelected.Descripcion,
              ) +
                "/" +
                data.RefInterna,
            );
          }
          if (data.UpdatedCodigoPA) {
            const MaterialesStore = useMaterialesStore();
            // await MaterialesStore.GetMaterialesByProductoAcabado(data.IdPA)
            const materiales = await services.MaterialService.getByIdPA(
              data.IdPA,
            );
            if (materiales && materiales.data) {
              materiales.data
                .filter((m) => m.CambioDiseno && m.IdProyectoPuntes)
                .forEach((material) => {
                  MaterialesStore.EnviarDatosAPuntes(
                    material,
                    data,
                    ProyectosStore.ProyectoSelected,
                  );
                });
            }
          }
        })
        .catch((error: Error) => {
          console.error("Error al actualizar el producto acabado:", error);
        });
    },
    async UploadFotoPA(data: ProductoAcabado, image: UploadUserFile) {
      if (image) {
        const imgUrl = await services.StorageService.uploadImage(
          image,
          data.IdProyecto + data.IdPA + "-" + image.name,
        );
        data.Foto = imgUrl;
        this.UpdateProductoAcabado(data);
      }
    },
    async UploadDocumentSharepoint(
      data: ProductoAcabado,
      folderPath: string,
      image: UploadUserFile,
    ) {
      if (image && folderPath) {
        const docUrl = await services.StorageService.uploadFileSharepoint(
          image,
          image.name,
          folderPath,
        );
        if (!data.Documentos) {
          data.Documentos = "";
        }
        data.Documentos += docUrl.fileUrl + ";";
        await this.UpdateProductoAcabado(data);
        return data.Documentos;
      }
    },
    async DeleteFileSharepoint(siteId: string, itemId: string) {
      if (siteId && itemId) {
        await services.StorageService.deleteFileSharepoint(siteId, itemId);
      }
    },
    async DeleteProductoAcabado(idProductoAcabado: number) {
      await services.ProductoAcabadoService.delete(idProductoAcabado)
        .then(() => {
          console.log("ProductoAcabado eliminada correctamente");
        })
        .catch((error: Error) => {
          console.error("Error al eliminar la PA:", error);
        });
    },
    DeleteProductoAcabadoStore(data: ProductoAcabado) {
      let index = -1;
      if (this.ProductosAcabados) {
        if (data.IdPA > 0) {
          index = this.ProductosAcabados.findIndex(
            (pa) => pa.IdPA === data.IdPA,
          );
        } else {
          index = this.ProductosAcabados.findIndex(
            (pa) => pa.TempId === data.TempId,
          );
        }
        this.ProductosAcabados.splice(index, 1);
      }
    },
    async GetSharepointData(data: ProductoAcabado, proyecto: Proyecto) {
      const { removeSpecialCharacters } = Helper();
      const documents: { libraryUrl: string; documents: DocumentoData[] } = {
        libraryUrl: "",
        documents: [],
      };
      let result = await services.AzureService.getGraphFolderSP(
        removeSpecialCharacters(proyecto.Descripcion) + "/" + data.RefInterna,
      );
      if (!result) {
        await services.AzureService.createFolderSP(
          removeSpecialCharacters(proyecto.Descripcion) + "/" + data.RefInterna,
        );
        result = await services.AzureService.getGraphFolderSP(
          removeSpecialCharacters(proyecto.Descripcion) + "/" + data.RefInterna,
        );
      }

      if (result) {
        documents.libraryUrl = result.webUrl;
        const resultData = await services.AzureService.getGraphItemsSP(
          result.id,
        );
        if (resultData && resultData.value.length > 0) {
          resultData.value.forEach((doc: any) => {
            documents.documents.push({
              downloadUrl: doc["@microsoft.graph.downloadUrl"],
              webUrl: doc.webUrl,
              name: doc.name,
              siteId: doc.parentReference.siteId,
              itemId: doc.id,
            });
          });
        }
      }

      return documents;
    },
    AddProductoAcabadoStore(data: ProductoAcabado) {
      this.ProductosAcabados?.push(data);
    },

    async EnviaraProduccion(
      email: EmailObj,
      prodAcabado: ProductoAcabado,
      materiales: Material[],
    ) {
      try {
        // Ejecutar ambas llamadas a SAP en paralelo
        // TODO Descomentar para subir a materiales a SAP, de momento como no se ha podido probar no se sube a Staging/PRO
        // const resultados = await Promise.all([
        //   services.SAPService.createMateriales(prodAcabado, materiales, 'Coste'),
        //   services.SAPService.createMateriales(prodAcabado, materiales, 'Produccion')
        // ]);

        // console.log("Resultados SAP:", resultados);

        // Si ambas llamadas fueron exitosas, enviar el email
        console.log(prodAcabado, materiales);
        try {
          await services.SenderEmailService.sendEmail(email);
          ElNotification.success({
            showClose: true,
            message: "Email enviado correctamente",
          });
        } catch (emailError: any) {
          ElNotification.error({
            showClose: true,
            message:
              "Se ha producido un error al enviar el email. " +
              (emailError.response?.data?.error?.originalMessage ||
                emailError.message),
          });
        }
      } catch (sapError: any) {
        ElNotification.error({
          showClose: true,
          message:
            "Se ha producido un error al enviar el mail. " +
            (sapError.response?.data || sapError.message),
        });
        console.log(
          "Se ha producido un error al enviar el mail.:",
          sapError.response?.data || sapError,
        );
      }
    },
    async GetSAPDataByReference(referencia: string) {
      const numCodigo = Number(referencia);
      let costeEstandar = null;
      if (!isNaN(numCodigo) && numCodigo > 0) {
        const response =await services.SAPService.getProductDetails(numCodigo, "1110")
        costeEstandar = response.data.GETDETAILResponse.MATERIALVALUATIONDATA
              .STD_PRICE["#text"];
        
      } else {
      ElNotification.error({
          showClose: true,
          message:
            "Se ha producido un error al obtener el coste estandar del código introducido. ",
        });
      }
        return costeEstandar;
    },

    // async EnviaraProduccion (email:EmailObj, prodAcabado:ProductoAcabado, materiales: Material[]) {
    //   // TODO Enviar  materiales a SAP
    //   await services.SAPService.createMateriales(prodAcabado, materiales).then(async (result) => {
    //     console.log(result)
    //     await services.SenderEmailService.sendEmail(email).then(() => {
    //       ElNotification.success({
    //         showClose: true,
    //         message: "Materiales creados en SAP y Email enviado correctamente",
    //       });
    //     })
    //     .catch((error) => {
    //       ElNotification.error({
    //         showClose: true,
    //         message: "Se ha producido un error al enviar el email. " + error.response.data.error ? error.response.data.error.originalMessage : error.message,
    //       });
    //     });
    //   })
    //   .catch((error) => {
    //     ElNotification.error({
    //       showClose: true,
    //       message: "Se ha producido un error al crear los materiales en SAP. " + error.response.data,
    //     });
    //     console.log("Error al crear los materiales en SAP:", error.response.data)
    //   })

    // }
  },
});
